import { Fragment, useEffect, useState } from "react";
import { Grid } from "@mui/material";

import FormOne from "./FormOne";
import { useAxios } from "../../../hooks";
import ActionButton from "./ActionButtons";
import AdminBrandStatus from "./BrandStatus";
import PrefrredChannels from "./PreffredChannels";
import ThresholdDialog from "./threshold dialog components/ThresholdDialog";
import { ComponentHeader, PageHeader, Paper } from "../../../components";

export default function FormDisplay({ state, formData, setFormData }) {
  const axios = useAxios();
  const [channels, setChannels] = useState([]);
  const [thresholdDialog, setThresholdDialog] = useState({ state: false });
  const [selectedChannel, setSelectedChannel] = useState(
    formData.prefrredChannel
  );

  useEffect(() => {
    axios({
      url: "/get/campaign/preferredChannels",
      disableRedirect: true,
      disableError: true,
    }).then((response) => {
      if (response.status) {
        setChannels(response.data);
      }
    });
  }, [axios]);

  return (
    <Fragment>
      <Grid size={12}>
        <PageHeader
          pageName={"Brand Details"}
          pageHeader={formData.brandName}
          buttons={[
            <ActionButton
              state={state}
              selectedChannel={selectedChannel}
              formData={formData}
              ID={formData.brandID}
              setFormData={setFormData}
              setThresholdDialog={setThresholdDialog}
            />,
          ]}
        />
      </Grid>

      <AdminBrandStatus state={state} formData={formData} />

      <Grid container spacing={8}>
        <Grid size={12}>
          <Paper gridSpacing={3}>
            <Grid size={12}>
              <ComponentHeader title={"Brand Details"} />
            </Grid>

            <FormOne formData={formData} />
          </Paper>
          {state?.component !== "platform" && formData.brandType === 2 && (
            <Grid size={12}>
              <Paper gridSpacing={6}>
                <PrefrredChannels
                  selectedChannel={selectedChannel}
                  setSelectedChannel={setSelectedChannel}
                  channels={channels}
                  formData={formData}
                />
              </Paper>
            </Grid>
          )}
        </Grid>
      </Grid>

      <ThresholdDialog
        setFormData={setFormData}
        brandID={formData.brandID}
        dialogState={thresholdDialog}
        setDialogState={setThresholdDialog}
      />
    </Fragment>
  );
}
